import { render } from "./GamesDetail.vue?vue&type=template&id=d3f0747a"
import script from "./GamesDetail.vue?vue&type=script&lang=js"
export * from "./GamesDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__